/* eslint-disable */
/**
 * React 19 Polyfill for ReactDOM.findDOMNode
 *
 * draft-js@0.10.x uses ReactDOM.findDOMNode which was removed in React 19.
 * This polyfill provides a temporary solution until we migrate to a modern editor.
 *
 * WARNING: This is a hack and should be replaced with a proper solution.
 * Consider migrating to:
 * - lexical (Facebook's modern text editor)
 * - tiptap
 * - slate
 */

import ReactDOM from 'react-dom';

export function findDOMNodePolyfill(componentOrElement) {
  if (componentOrElement instanceof Element) {
    return componentOrElement;
  }

  if (componentOrElement && componentOrElement._reactInternals) {
    const fiber = componentOrElement._reactInternals;

    let currentFiber = fiber;
    while (currentFiber) {
      if (currentFiber.stateNode instanceof Element) {
        return currentFiber.stateNode;
      }
      currentFiber = currentFiber.child;
    }
  }

  if (componentOrElement && componentOrElement.editorContainer) {
    if (componentOrElement.editorContainer instanceof Element) {
      return componentOrElement.editorContainer;
    }

    if (componentOrElement.editorContainer.current instanceof Element) {
      return componentOrElement.editorContainer.current;
    }
  }

  if (componentOrElement && componentOrElement.editor) {
    const editorElement = componentOrElement.editor;
    if (editorElement instanceof Element) {
      return editorElement;
    }
    if (editorElement && editorElement.editor instanceof Element) {
      return editorElement.editor;
    }
  }

  console.warn(
    'findDOMNode polyfill: Could not find DOM node for component',
    componentOrElement
  );

  return null;
}

// Patch ReactDOM global for legacy draft-js compatibility
if (ReactDOM && !ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = findDOMNodePolyfill;
}
